import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";
import { DependentGridList } from "src/app/models/dependent-grid";
import { DocumentStatusDialogModel, FileUploadDialogModel } from "src/app/models/dialog";
import { TableColumn } from "src/app/models/table";
import { DependentsService } from "src/app/services/dependents.service";
import { DialogFileUploadComponent } from "src/app/components/shared/dialog/file-upload.component";
import { DialogDocumentStatusComponent } from "src/app/components/shared/dialog/document-status.component";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { SessionService } from "src/app/services/storage/session.service";

@Component({
    selector: "mwp-dependent-verification",
    templateUrl: "./dependent-verification.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class DependentVerificationComponent implements OnInit {
    public apiUrl = ContentHeaderKey.EnrollmentDependentVerification;

    public dependentMatTableData: MatTableDataSource<DependentGridList>;
    public dependentColumns: TableColumn[] = [
        {
            columnName: 'Name',
            propertyId: 'dependentName',
            columnType: TableColumnType.label,
            width: "25%"
        },
        {
            columnName: 'Relationship',
            propertyId: 'dependentRelationship',
            columnType: TableColumnType.label,
            width: "15%"
        },

        {
            columnName: 'Gender',
            propertyId: 'dependentGender',
            columnType: TableColumnType.label,
            width: "15%"
        },
        {
            columnName: 'Documents',
            propertyId: 'dependentAge',
            columnType: TableColumnType.button,
            isButtonSelection2: true,
            dataTypeText: 'View Uploads',

            isBooleanPropertyId: 'dependentHasVerificationDocuments'

        },
        {
            columnName: 'Upload Verification Documents',
            propertyId: 'dependentID',
            columnType: TableColumnType.button,
            dataTypeText: 'Upload',
        },
    ];

    constructor(
        private dependentsService: DependentsService,
        public dialog: MatDialog,
        private sessionService: SessionService,
    ) {
    }

    ngOnInit(): void {
        this.dependentsService.getDependents().subscribe((response: DependentGridList[]) => {
            this.dependentMatTableData = new MatTableDataSource<DependentGridList>();
            this.dependentMatTableData.data = response;
        });
    }

    public openUploadDialog(dependent: any): void {
        const l_FileUploadDialogModel = new FileUploadDialogModel();
        l_FileUploadDialogModel.dependentId = dependent.dependentID;
        const dialogRef = this.dialog.open(DialogFileUploadComponent, { data: l_FileUploadDialogModel, panelClass: this.sessionService.session.member.companyName == 'FLYNN RESTAURANT GROUP' ? 'mwp-modal-override-1300' : 'mwp-modal-override-600' });

        dialogRef.afterClosed().subscribe((response: DependentGridList[]) => {
            if (response) {
                this.dependentMatTableData = new MatTableDataSource<DependentGridList>();
                this.dependentMatTableData.data = response;
            }
        });
    }

    public openStatusDialog(dependent: any): void {
        const l_DocumentStatusDialogModel = new DocumentStatusDialogModel();
        l_DocumentStatusDialogModel.dependentId = dependent.dependentID;
        l_DocumentStatusDialogModel.isDependentVerification = true;
        const dialogRef = this.dialog.open(DialogDocumentStatusComponent, { data: l_DocumentStatusDialogModel, panelClass: 'mwp-modal-override-800' });
    }
}